import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guardiasenturno',
  templateUrl: './guardiasenturno.component.html',
  styleUrls: ['./guardiasenturno.component.css']
})
export class GuardiasenturnoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
